<ins-opt-in-notification-container></ins-opt-in-notification-container>
<ins-notification-banner-container></ins-notification-banner-container>

<section class="section section--content section--mobile">
    <div class="container">
        <ins-report-claim-button [labelArrow]="false"></ins-report-claim-button>
    </div>
</section>

<div class="container">
    <div class="myzone">
        <h1>Mijn Verzekeringsmap</h1>
    </div>
</div>

<section id="topbar" class="section--border section--vertical-spacing section--sticky section--desktop">
    <div class="container">
        <div class="myzone__container">
            <ins-sticky-bar class="myzone__sticky-bar">
                <ins-sticky-bar-first>
                    <ins-chatbot-entry-container></ins-chatbot-entry-container>
                </ins-sticky-bar-first>
                <ins-sticky-bar-second [hideMobile]="true">
                    <ins-report-claim-button></ins-report-claim-button>
                </ins-sticky-bar-second>
            </ins-sticky-bar>
        </div>
    </div>
</section>

<section class="section section--content">
    <div class="container">
        <div class="wrapper">
            <!-- TODO: WINS-1728 - Change to regular grid col-4, col-8 -->
            <div class="col-3 myzone__sidemenu">
                <ins-sidemenu></ins-sidemenu>
            </div>
            <div class="col-9 myzone__outlet">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</section>

<section *ngIf="!inMyZoneRoot" id="zelf-regelen" class="section section--content section--grey">
    <div class="container">
        <ins-insurance-control-container [onDark]="true"></ins-insurance-control-container>
    </div>
</section>

<section class="section section--content">
    <div class="container">
        <h2>Verzekeringen toevoegen</h2>
        <ins-insurance-images-container
            e2e="productpage-links"
            [insurances]="[
                productIdEnum.Car,
                productIdEnum.Liability,
                productIdEnum.Home,
                productIdEnum.Furniture,
                productIdEnum.Moped,
                productIdEnum.Travel,
                productIdEnum.Pet,
                productIdEnum.Caravan,
                productIdEnum.Bicycle,
                productIdEnum.Legal,
                productIdEnum.Building,
                productIdEnum.Accidents,
                productIdEnum.Scooter,
                productIdEnum.Motorcycle
            ]"
        ></ins-insurance-images-container>
    </div>
</section>

<section id="nieuws-en-leuks" class="section section--content section--grey">
    <div class="container">
        <h2 class="text-center">Slimme tips</h2>
        <p class="text-center">laatste nieuws, leuke weetjes en handige preventietips!</p>
        <ins-news-carousel [itemsInView]="3"></ins-news-carousel>
        <p class="text-center">
            Meer leuke weetjes en handige preventietips?
            <a href="/slimme-tips">Bekijk</a>
            de overzichtpagina
        </p>
    </div>
</section>
